import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { PageHeader, Form, Input, Button, Switch, Cascader, Spin, message, InputNumber } from 'antd';

import * as ToolRequest from '../../tools/ToolRequest';

import SpinFull from '../../components/SpinFull';
import CropNameBadge from '../../components/CropNameBadge';

const formLayout = {
  labelCol: {
    sm: { span: 5 },
  },
  wrapperCol: {
    sm: { span: 16 },
  },
  labelWrap: true,
};

const formTailLayout = {
  wrapperCol: {
    sm: { offset: 5, span: 16 },
  },
};

export default function FarmCropEditScreen(props) {
  const history = useHistory();
  const { cropId } = useParams();

  const [loaded, setLoaded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [crop, setCrop] = useState(null);
  const [company, setCompany] = useState(null);

  useEffect(() => {
    (async () => {
      const cropRes = await ToolRequest.request('GET', `/v1/farm-crop/${cropId}`);
      setCrop({
        ...cropRes,
        companyId: [cropRes.companyId],
      });

      const companyRes = await ToolRequest.request('GET', `/v1/company/${cropRes.companyId}`);
      setCompany(companyRes);

      setLoaded(true);
    })();
  }, []);

  const onFinish = async (values) => {
    setLoading(true);

    try {
      await ToolRequest.request('PUT', `/v1/farm-crop/${cropId}`, {
        name: values.name,
        seedlingDayCount: values.seedlingDayCount,
        plantingDayCount: values.plantingDayCount,
        remarks: values.remarks,
        isEnabled: values.isEnabled,
      });

      message.success('Update Crop successfully');

      history.push('/farm-crop');
    } catch (err) {
      setLoading(false);

      if (err?.response?.data) {
        switch (err.response.data) {
          default:
            return message.error('Unknown errors. Please retry');
        }
      }

      message.error('Unknown error. Please retry');
    }
  };

  return loaded ? (
    <PageHeader
      title={(
        <>
          Edit Crop (
          <CropNameBadge name={crop.name} />
          )
        </>
      )}
      onBack={() => history.push('/farm-crop')}
    >
      <Spin spinning={loading}>
        <Form
          {...formLayout}
          initialValues={crop}
          onFinish={onFinish}
        >
          <Form.Item
            label="Company"
            name="companyId"
          >
            <Cascader
              options={[
                {
                  value: company.id,
                  label: `${company.displayName} (${company.name})`,
                },
              ]}
              disabled={true}
            />
          </Form.Item>

          <Form.Item
            label="Name"
            name="name"
            rules={[
              {
                required: true,
                message: 'Please enter the name',
              },
            ]}
          >
            <Input
              placeholder="Name"
            />
          </Form.Item>

          <Form.Item
            label="Propagation Days"
            name="seedlingDayCount"
            rules={[
              {
                required: true,
                message: 'Please enter the propagation days',
              },
            ]}
          >
            <InputNumber
              placeholder="Days"
              min={1}
            />
          </Form.Item>

          <Form.Item
            label="Grow Days"
            name="plantingDayCount"
            rules={[
              {
                required: true,
                message: 'Please enter the grow days',
              },
            ]}
          >
            <InputNumber
              placeholder="Days"
              min={1}
            />
          </Form.Item>

          <Form.Item
            label="Remarks"
            name="remarks"
          >
            <Input.TextArea
              placeholder="Remarks"
            />
          </Form.Item>

          <Form.Item
            label="Enabled"
            name="isEnabled"
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>

          <Form.Item {...formTailLayout}>
            <Button type="primary" htmlType="submit" block>
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    </PageHeader>
  ) : <SpinFull />;
};
